import {
    decomposeColor,
    recomposeColor,
} from '@material-ui/core/styles';

/**
 * Adjusts the transparency for a given color string
 */
export const makeTransparent = (color: string, transparency = 0.14): string => {
    const colorObject = decomposeColor(color);
    colorObject.values[3] = transparency;
    return recomposeColor(colorObject);
};

/**
 * Derive a color from a string
 * @param str Some string
 * @param saturation Saturation; [0..100]
 * @param luminescence Luminescence; [0..100]
 */
export const stringToHslColor = (str: string, saturation: number, luminescence: number) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const h = hash % 360;
    return `hsl(${h}, ${saturation}%, ${luminescence}%)`;
};
